import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import * as S from "../svg.style";
export var TickLs = function(_param) /*#__PURE__*/ {
    var color = _param.color, height = _param.height, width = _param.width, shrinkable = _param.shrinkable, rest = _object_without_properties(_param, [
        "color",
        "height",
        "width",
        "shrinkable"
    ]);
    return _jsx(S.Svg, _object_spread_props(_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        height: height,
        width: width,
        viewBox: "0 0 17.033 17.033",
        shrinkable: shrinkable
    }, rest), {
        children: /*#__PURE__*/ _jsx("path", {
            fill: color,
            d: "M1.652 7.835A.964.964 0 0 0 .288 9.2l5.03 5.03a.964.964 0 0 0 1.364 0L16.744 4.17a.966.966 0 1 0-1.365-1.366L6 12.183 1.653 7.834z"
        })
    }));
};
